/**
 * CargaTransfolhaCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {CargaTransfolha} from '@/model/resource/CargaTransfolha'

/* TODO: review generated class */
@HttpExclude()
export class CargaTransfolhaCollection extends PageCollection<CargaTransfolha> {
  constructor() {
    super(CargaTransfolha)
  }

  queryAsPage() {
    return this.listCargaTransfolha()
  }

  async listCargaTransfolha() {
    return await Request.get(`/admin/carga-transfolha`, {params: this.params})
      .name('listCargaTransfolha')
      .as(this)
      .getResponse()
  }

  async listCsvCargaTransfolha() {
    return await Request.get(`/admin/carga-transfolha/csv`, {
      params: this.params,
    })
      .name('listCsvCargaTransfolha')
      .as(this)
      .getResponse()
  }
}
